import React, { useEffect } from "react";
import { Modal } from "antd";
export default function GenericFormModal({
  children,
  isVisible,
  actions,
  modalConfig,
}) {
  const { toggleGenericModal, save } = actions;

  const { width } = modalConfig;

  return (
    <div className="GenericFormModal">
      <Modal
        footer={null}
        visible={isVisible}
        onCancel={toggleGenericModal}
        onOk={save}
        closable={false}
        destroyOnClose
        maskClosable={false}
        width={width ?? "auto"}
      >
        {children}
      </Modal>
    </div>
  );
}
